// src/Components/videochat/CallGiftCelebration.jsx
//
// Celebración de un regalo sobre el video de la llamada. A diferencia de la del
// chat normal (GiftCelebration), NO oscurece el fondo y los toques pasan a
// través: el video sigue a la vista. Dura 2,6 s. Con «reducir movimiento» no
// hay lluvia ni crecimiento, solo el regalo que aparece y se va con un fundido.
import React, { useEffect, useMemo } from 'react'

const DURATION_MS = 2600
const RAIN_COUNT = 14

export default function CallGiftCelebration({ gift, kind, reduceMotion, onDone }) {
  useEffect(() => {
    if (!gift) return
    try { navigator.vibrate?.([30, 50, 30]) } catch {}
    const t = setTimeout(onDone, DURATION_MS)
    return () => clearTimeout(t)
  }, [gift, onDone])

  // Posiciones fijas por regalo para que no salten entre renders.
  const rain = useMemo(() => Array.from({ length: RAIN_COUNT }, (_, i) => ({
    left: 6 + ((i * 53) % 88),
    size: 22 + ((i * 7) % 19),
    delay: (i / RAIN_COUNT) * 0.48,
  })), [gift])

  if (!gift) return null
  const sent = kind === 'sent'
  const title = sent ? '¡Regalo enviado!' : '¡Recibiste un regalo!'
  const label = `${sent ? 'Regalo enviado' : 'Recibiste un regalo'}: ${gift.name}`

  return (
    <div className="pointer-events-none absolute inset-0 z-[25] overflow-hidden" role="status" aria-live="polite" aria-label={label}>
      <style>{`
        @keyframes vc-gift-pop { 0% { transform: scale(.4); opacity: 0 } 60% { transform: scale(1.12); opacity: 1 } 100% { transform: scale(1); opacity: 1 } }
        @keyframes vc-gift-fade { 0%, 80% { opacity: 1 } 100% { opacity: 0 } }
        @keyframes vc-gift-rain { 0% { transform: translateY(0); opacity: 0 } 15% { opacity: 1 } 100% { transform: translateY(-78vh); opacity: 0 } }
      `}</style>
      <div
        className="absolute inset-0 flex flex-col items-center justify-center text-center"
        style={{ animation: `vc-gift-fade ${DURATION_MS}ms linear forwards` }}
      >
        <div style={{ fontSize: 120, lineHeight: 1, animation: reduceMotion ? 'none' : 'vc-gift-pop .5s cubic-bezier(.3,1.5,.5,1) both', filter: 'drop-shadow(0 4px 12px rgba(0,0,0,.5))' }}>
          {gift.emoji}
        </div>
        <p className="mt-3 text-lg font-bold text-white" style={{ textShadow: '0 2px 8px rgba(0,0,0,.7)' }}>{title}</p>
        <p className="text-sm font-medium text-white" style={{ textShadow: '0 2px 8px rgba(0,0,0,.7)' }}>
          {gift.name} · {gift.coins} coins
        </p>
      </div>
      {!reduceMotion && rain.map((r, i) => (
        <span
          key={i}
          className="absolute bottom-0"
          style={{
            left: `${r.left}%`, fontSize: r.size,
            animation: `vc-gift-rain 2.2s ease-out ${r.delay}s both`,
          }}
        >
          {gift.emoji}
        </span>
      ))}
    </div>
  )
}
